import { CardHolderField } from './CardHolderField';
import { CardInformationFields } from './CardInformationFields';

export const PaymentCardFields = () => (
    <>
        <CardInformationFields />
        <CardHolderField />
    </>
);
